import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String, label: { type: String, default: "Copied!" } }

  async copy(event) {
    event.preventDefault()
    event.stopPropagation()

    const text = this.textValue
    if (!text) return

    const button = event.currentTarget

    try {
      await navigator.clipboard.writeText(text)
    } catch (_err) {
      const ta = document.createElement("textarea")
      ta.value = text
      ta.setAttribute("readonly", "")
      ta.style.position = "absolute"
      ta.style.left = "-9999px"
      document.body.appendChild(ta)
      ta.select()
      try { document.execCommand("copy") } catch (_) {}
      ta.remove()
    }

    if (button) this.flash(button)
  }

  flash(button) {
    const original = button.dataset.originalLabel || button.textContent
    button.dataset.originalLabel = original
    button.textContent = this.labelValue
    button.classList.add("copy-flash")
    clearTimeout(this._flashTimer)
    this._flashTimer = setTimeout(() => {
      button.textContent = original
      button.classList.remove("copy-flash")
    }, 1200)
  }
}
